import NumberElement from './Number';
import WrapComponent from '../WrapComponent';

export default WrapComponent(NumberElement);



// WEBPACK FOOTER //
// ./src/component/Number/index.js